import { Router, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";

import Template from "./template/Template";
import AuthPage from "./features/auth/AuthPage";
import LogoutPage from "./features/logout/LogoutPage";

import { authService } from "./common/services/authService";

const history = createBrowserHistory({ basename: "/" });

export default function App() {
  return (
    <Router history={history}>
      <Switch>
        <Route path="/auth" component={AuthPage} />
        <Route path="/logout" component={LogoutPage} />
        <Route path="/" component={authService.withPrivateRoute(Template)} />
      </Switch>
    </Router>
  );
}
